import React from 'react'
import { LandingPage } from './components/landingPage/LandingPage'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { BrandAssetsVc } from './components/brandAssets/BrandAssetsVc'
import { BrandAssets } from './components/brandAssets/BrandAssets'
import { BlogListPage } from './components/blog/BlogListPage'
import { BlogPostPage } from './components/blog/BlogPostPage'
import { SeoTags } from './components/seo/Seo'
import { getSeoByPath } from './config/seo'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <>
        <SeoTags {...getSeoByPath('/')} />
        <LandingPage />
      </>
    )
  },
  {
    path: 'brand',
    element: (
      <>
        <SeoTags {...getSeoByPath('/brand')} />
        <BrandAssets />
      </>
    )
  },
  {
    path: 'brand-linkpool-vc',
    element: (
      <>
        <SeoTags {...getSeoByPath('/brand-linkpool-vc')} />
        <BrandAssetsVc />
      </>
    )
  },
  {
    path: 'blog',
    element: <BlogListPage />
  },
  {
    path: 'blog/:slug',
    element: <BlogPostPage />
  },
  {
    path: '*',
    element: (
      <>
        <SeoTags {...getSeoByPath('/')} />
        <LandingPage />
      </>
    )
  }
])

export const App = () => {
  return <RouterProvider router={router} />
}
